import { AdsLimit, LimitsListItem } from './types';

export function mapLimitsList(limits: AdsLimit[]): LimitsListItem[] {
  return limits.map(
    ({ category, availableFreeLimit, availablePaidLimit, limitUntil }) => {
      const { legacyResourceId, parent, name, icon } = category;

      return {
        id: legacyResourceId,
        iconUrl: parent?.icon ?? icon,
        categoryName: parent?.name ?? '',
        subcategoryName: name,
        freeCount: availableFreeLimit,
        paidCount: availablePaidLimit,
        totalCount: availableFreeLimit + availablePaidLimit,
        limitUntil,
      };
    }
  );
}
